import React, { useEffect, useRef, useState } from 'react'
import { SliderComponent } from './SliderComponent'
import { useNavigate } from 'react-router-dom'
import { getAllActivity, getCountAllActivity } from '../../../asiosConfig';
import { toast } from 'react-toastify';
import left from "../../../images/left.svg";
import right from "../../../images/right.svg";
import { Box, Button, CircularProgress, Grid, Typography, Skeleton } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../services/firebaseConfig';

export const Activity = () => {
    const [activity, setActivity] = useState([]);
    const [activityCount, setActivityCount] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const sliderRef = useRef(null);

    useEffect(() => {
        const fetchActivity = async () => {
            setLoading(true);
            try {
                const response = await getAllActivity();
                if (response.status === 200 || response.status === 201) {
                    setActivity(response.data.data);
                } else {
                    console.error('Error fetching activity:', response.data.message);
                }
            } catch (error) {
                toast.error(error);
            }
        }

        const fetchAllCount = async () => {
            try {
                const response = await getCountAllActivity();
                if (response.status === 200 || response.status === 201) {
                    setActivityCount(response.data);
                }
            } catch (error) {
                toast.error(error);
            } finally {
                setLoading(false);
            }
        }
        fetchActivity();
        fetchAllCount();
    }, []);

    const handleViewAllClick = (matchesType) => {
        navigate(`/${matchesType}`);
    }

    const handleSearch = (profileId) => {
        try {
            logEvent(analytics, 'view_profile', {
                viewed_profile_id: profileId,
                profile_viewer_id: localStorage.getItem('user'),
                timestamp: new Date().toISOString(),
            })
            navigate('/profile-view', { state: { user_id: profileId } });
        } catch (error) {
            toast.error('Something Went Wrong:', error);
        }
    };

    const formatTitle = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    }

    const activityCountArray = Object.keys(activityCount).map(key => ({
        title: key.replace(/_/g, ' ').toUpperCase(),
        title_key: key,
        count: activityCount[key]
    }));

    const renderSlider = () => {
        if (activity && typeof activity === 'object' && Object.keys(activity).length > 0) {
            return Object.entries(activity).map(([key, value]) => {
                const hasData = Array.isArray(value)
                    ? value.length > 0
                    : value && typeof value === 'object' && value.profiles && value.profiles.length > 0;

                if (hasData) {
                    return (
                        <div key={key}>
                            <SliderComponent
                                data={Array.isArray(value) ? value : value.profiles || value}
                                title={formatTitle(key)}
                                matchesType={key}
                                onViewAllClick={handleViewAllClick}
                                onProfileClick={(userId) => handleSearch(userId)}
                            />
                            <br />
                        </div>
                    );
                }
                return null;
            });
        }
        return null;
    };

    const scrollSlider = (direction) => {
        const slider = sliderRef.current;
        if (slider) {
            const scrollAmount = direction === 'left' ? -slider.clientWidth : slider.clientWidth;
            slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    return (
        <Box className="col-lg-9 col-12">
            <Box sx={{ width: '100%' }}>
                <Box className="activPro">
                    {loading ? (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Skeleton variant="rectangular" width="200px" height="80px" sx={{ margin: 1 }} />
                            <Skeleton variant="rectangular" width="200px" height="80px" sx={{ margin: 1 }} />
                            <Skeleton variant="rectangular" width="200px" height="80px" sx={{ margin: 1 }} />
                            <Skeleton variant="rectangular" width="200px" height="80px" sx={{ margin: 1 }} />
                        </Box>
                    ) : (
                        <Box className="sliderContainer" sx={{ position: 'relative', overflow: 'hidden' }}>
                            <Button className="btn btn-light btn-left" onClick={() => scrollSlider('left')} sx={{ position: 'absolute', top: '35%', left: 0, transform: 'translateY(-50%)', zIndex: 1 }}>
                                <img src={left} width="15px" alt="left" />
                            </Button>
                            <Box className="slider" ref={sliderRef} sx={{ display: 'flex', overflowX: 'scroll', scrollBehavior: 'smooth', padding: 2, background: 'white' }}>
                                {activityCountArray.map((item, index) => (
                                    <Box key={index} className={`colorBg colorBg${index + 1}`} sx={{ flex: '0 0 auto', cursor: 'pointer', padding: 2, textAlign: 'center', minWidth: '200px', marginRight: '16px' }} onClick={() => handleViewAllClick(item.title_key)}>
                                        <Typography variant="h5">{item.count}</Typography>
                                        <Typography variant="body1">{item.title?.toLowerCase().includes('who looking for me') ? 'LOOKING FOR ME' : item.title?.toLowerCase().includes('premium') ? 'PREMIUM MATCHES' : item.title} {''}</Typography>
                                    </Box>
                                ))}
                            </Box>
                            <Button className="btn-right" onClick={() => scrollSlider('right')} sx={{ position: 'absolute', top: '35%', right: 0, transform: 'translateY(-50%)', zIndex: 1 }}>
                                <img src={right} width="15px" alt="right" />
                            </Button>
                        </Box>
                    )}

                    <Box className="scrollProfileSec">
                        {renderSlider()}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
